import TextInput from '../../../components/input_fields/TextInput';
import SelectInput from '../../../components/input_fields/SelectInput';
import TwoInputs from '../../../components/input_fields/TwoInputs'
import validator from "validator";
import React, { useState } from "react";
import FormTitle from '../../../components/form_titles/FormTitle';
import { Link } from "react-router-dom";
import ApplicationTitle from '../../../components/ApplicationTitle';
import BipsyLogo from "../../../img/BipsyPay/Bipsy.png"

export default function Form({ nextStep, nextHalfStep, handleFormData, values, validation }) {

    const [phoneError, setPhoneError] = useState(false)
    const [emailError, setEmailError] = useState(false)
    const [busError, setBusError] = useState(false)
    const [fnameError, setfnameError] = useState(false)
    const [lnameError, setlnameError] = useState(false)
    const [contactError, setContactError] = useState(false)

    const submitFormData = (e) => {

        e.preventDefault()
        
        if (validation) {
            console.log(validator.isEmpty(values.ContactMethod))
            //fname Errors
            if (validator.isEmpty(values.FirstName)) {
                setfnameError(true)
                return
            } setfnameError(false)

            //lname Errors
            if (validator.isEmpty(values.LastName)) {
                setlnameError(true)
                return
            } setlnameError(false)

            // Bussiness Name Errors
            if (!validator.isAlphanumeric(values.BusinessName, 'en-US', { ignore: ' \&-' })) {
                setBusError(true)
                return
            } setBusError(false)

            // Contact Errors
            if (validator.isEmpty(values.ContactMethod)) {
                setContactError(true)
                return
            } setContactError(false)

            // Phone Errors
            if (values.ContactMethod === "direct phone call") {
                if (!validator.isMobilePhone(values.Phone)) {
                    setPhoneError(true)
                    return
                } setPhoneError(false)
            }


            // Email Errors
            if (values.ContactMethod === 'email') {
                if (!validator.isEmail(values.Email)) {
                    setEmailError(true)
                    return
                } setEmailError(false)
            }

        }


        // Make sure to check all validation BEFORE running this *** 
        nextStep()
    };

    return (
        <div className="bg-white-900 dark:bg-white-900 w-full">
            <div className="items-center px-8 py-8 my-10 mx-auto w-fit py-0">
                <div className="flex text-center justify-center mb-4 text-4xl font-bold text-black">
                    <img className="h-16" src={BipsyLogo} />
                </div>
                <div className="bg-white rounded-lg shadow dark:border">
                    <div className="p-6 space-y-1 sm:p-8">
                        <FormTitle
                            mainTitle="Let's get"
                            colorTitle="in touch."
                            subText="Please provide your contact information below."
                        />
                        <form className="space-y-4 " onSubmit={submitFormData}>
                            <TwoInputs
                                placeholder1="First Name" id1="first_name" type1="Text" name1="FirstName" value1={values.FirstName}
                                error1={fnameError} message1="Please enter your first name"
                                handleInputChange1={handleFormData}
                                placeholder2="Last Name" id2="last_name" type2="Text" name2="LastName" value2={values.LastName}
                                error2={lnameError} message2="Please enter your last name"
                                handleInputChange2={handleFormData}
                            />
                            <TextInput placeholder="Business Name" name="BusinessName" value={values.BusinessName}
                                error={busError} message="Please enter a business name"
                                handleInputChange={handleFormData} />

                            {values.ContactMethod == "" &&
                                <SelectInput placeholder="Contact Method" name="ContactMethod" options={["direct phone call", "email"]} value={values.ContactMethod}
                                    error={contactError} message="Please select a contact type"
                                    handleInputChange={handleFormData} />
                            }


                            {values.ContactMethod === "direct phone call" &&
                                <>
                                    <SelectInput placeholder="Contact Method" name="ContactMethod" options={["direct phone call", "email"]} value={values.ContactMethod}
                                        handleInputChange={handleFormData} />

                                    <TextInput placeholder="Phone Number" name="Phone" value={values.Phone}
                                        error={phoneError} message="Please enter a valid phone number"
                                        handleInputChange={handleFormData} />
                                </>

                            }

                            {values.ContactMethod === "email" &&
                                <>
                                    <SelectInput placeholder="Contact Method" name="ContactMethod" options={["direct phone call", "email"]} value={values.ContactMethod}
                                        handleInputChange={handleFormData} />

                                    <TextInput placeholder="Email" name="Email" value={values.Email}
                                        error={emailError} message="Please enter a valid email"
                                        handleInputChange={handleFormData} />

                                </>


                            }
                            <div className="flex flex-wrap -mx-3 mb-4">
                                <div className="w-full md:w-1/2 px-3 mb-4 md:mb-0">
                                    <Link to="/promo"><button className="w-full text-white bg-primary-200 hover:bg-primary-300 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Back</button></Link>
                                </div>
                                <div className="w-full md:w-1/2 px-3">
                                    <button type="submit" className="w-full text-white bg-primary-200 hover:bg-primary-300 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Submit</button>
                                </div>
                            </div>



                        </form>
                    </div>
                </div>
                <div className="bg-white rounded-lg shadow">
                    <div className="p-6 mt-8 space-y-1 sm:p-8">
                        <h4 className="text-xl text-center md:text-left items-center text-black mb-4">
                            Or speak with an expert:
                        </h4>
                        <div className="flex flex-wrap text-center md:text-left -mx-3 mb-4">
                            <div className="text-4xl mb-2 text-black font-bold mb-4">
                                833-MYCASH7 (833.692.2747)
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}